import styled from "styled-components"

const ETA = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  font-size: ${props => props.theme.font.size.button};
  line-height: 15px;
  color: ${props => props.theme.color.text};
`

export default ETA
